import { render, staticRenderFns } from "./IntermediateProductDiscard.vue?vue&type=template&id=5da053fe"
import script from "./IntermediateProductDiscard.vue?vue&type=script&lang=js"
export * from "./IntermediateProductDiscard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports